import { render, staticRenderFns } from "./PerformanceIcon.vue?vue&type=template&id=e9db4cd2&scoped=true"
import script from "./PerformanceIcon.vue?vue&type=script&lang=js"
export * from "./PerformanceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9db4cd2",
  null
  
)

export default component.exports